import React from 'react';
import footerlogo from '../assests/img/footer-logo.png';
import { SiGooglemaps } from "react-icons/si";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer>
      <section class="footer-main">
    <div class="container">

    <div class="row">
    <div className='foot-logo text-center col-md-12'>
        <img src={footerlogo}/>
      </div>
    </div>
        <div class="row">
            <div className='foot-01 col-md-3'>
            <h3>About Aadikaash</h3>
            <p>Aadikaash International is proud to present the India's biggest specific Silver Exhibition, a unique B2B Silver Show that brings together the best of best from the Silver jewellery industry. With over 10 years of experience in organizing successful B2B jewellery exhibitions, ISJS & AIJE is known for its commitment to quality and excellence.</p>            
            </div>
           



            <div className='foot-02 col-md-3'>
            <h3>Quick Links</h3>
            <ul className='foot-menu'>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Aadikaash</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/terms-and-condition">Terms and Conditions</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/refund-policy">Refund Policy</a></li>
              <li><a href="/cancellation-policy">Cancellation Policy</a></li>
            </ul>            
            </div>

            <div className='foot-03 foot-address col-md-3'>
            <h3>Keep In Touch</h3>
            <ul className='foot-menu'>
              <li><SiGooglemaps /> A-3, 1st Floor, Prahlad Market,D.B. Gupta Road,Karol Bagh,New Delhi-110005</li>
              <li><FaPhoneAlt /> <a href="tel:+91 999 0488 166">+91 999 0488 166</a>, <a href="tel:+91 96726 07607">+91 96726 07607</a></li>
              <li><MdEmail /> <a href="mailto:aadikaashgroup@gmail.com">aadikaashgroup@gmail.com</a></li>
            </ul> 
            </div>

            <div className='foot-04 col-md-3'>
            <h3>Follow Us</h3>
            <ul className='social-menu'>
              <li> <a href="https://www.facebook.com/AadikaashInternational/"><FaFacebook /> facebook</a></li>
              <li>  <a href="https://www.youtube.com/@aadikaashinternational4730"><FaYoutube /> Youtube</a></li>
              <li>  <a href="https://www.instagram.com/aadikaashofficial/"><FaInstagram /> Instagram</a></li>
            </ul>  
            </div>
         
        </div>
    </div>
</section>
      </footer>
  )

}

export default Footer;
